// Import System requirements
import Vue from 'vue'
import VueRouter from 'vue-router'
import 'babel-polyfill'
import { sync } from 'vuex-router-sync'
import routes from './routes'
import store from './store'
import config from './config'

// Import Helpers for filters
import { domain, count, prettyDate, pluralize,dateToString ,stringToDate,strToDate} from './filters'

// Import Views - Top level
import AppView from './components/App.vue'

// import element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'

import 'iview/dist/styles/iview.css'

// page-body css
import PageBody from './common/PageBody'
Vue.component("page-body", PageBody);
// import VueWebsocket from "vue-websocket";
// Vue.use(VueWebsocket);
// Vue.use(VueWebsocket,"ws://localhost:8080");

// import VueStomp from "vue-stomp";
// import VueStomp from "../static/js/vue-stomp.js"; 
// import Stomp from "../static/js/stomp.js"; 
// import Sockjs from "../static/js/sockjs.min.js"; 
// Vue.use(Stomp);
// Vue.use(Sockjs);
// Vue.use(Sockjs,"ws://localhost:8080");
// Vue.use(VueStomp, "http://localhost:8080/endpoint");

// import Stomp from "stompjs";

// var Stomp = require('stompjs');
// Vue.use(Stomp);
// import VueStomp from "vue-stomp";

import '../static/css/common.css'

Vue.prototype.strToDate = strToDate;

// Import Install and register helper items
Vue.filter('count', count)
Vue.filter('domain', domain)
Vue.filter('prettyDate', prettyDate)
Vue.filter('pluralize', pluralize)
Vue.filter('dateToString', dateToString)
Vue.filter('stringToDate', stringToDate)
Vue.filter('strToDate', strToDate)


Vue.use(VueRouter)

Vue.use(ElementUI)
// Routing logic
var router = new VueRouter({
  routes: routes,
  mode: 'history',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  // window.console.log('Transition', transition)
  if (to.auth && (to.router.app.$store.state.token === 'null')) {
    window.console.log('Not authenticated')
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
})

sync(store, router)

// Start out app!
// eslint-disable-next-line no-new
new Vue({
  el: '#root',
  router: router,
  store: store,
  render: h => h(AppView),
  mounted:function(){

    //通知 websocket
    /*var socket = io.connect(config.wsUrl);
    socket.on("message", function(obj){
      store.commit('SET_MSGTEST', JSON.parse(obj))
    });*/
  }
})

// Check local storage to handle refreshes
if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null'
  var localUser = JSON.parse(localUserString)

  if (localUser && store.state.user !== localUser) {
    store.commit('SET_USER', localUser)
    store.commit('SET_TOKEN', window.localStorage.getItem('token'))
  }
}



// WEBPACK FOOTER //
// ./src/main.js